import Vue from "vue";
import Faqs from "@/components/Faqs.vue";

new Vue({
    render: h => h(Faqs,{
        props: {
            faqs: faqs['Pregunta-frecuente']['value'],
            description: faqs['descripcion'] ? faqs['descripcion']['value'] : null,
            title: faqs['titulo'] ? faqs['titulo']['value'] : '<p>Preguntas frecuentes</p>',
            custom_faqs: faqs['custom_faqs']
        }
    })
}).$mount('#faqs')